import { useContext } from 'react'
import styled from '@emotion/styled';
import { ModalContainer,IconContainer,UIcon,SubmitContainer,StyleButton } from './CreateAdminUser';
import { useModal, useSettingModal } from '../../../../hooks/Context';
import { useQueryClient,useMutation } from '@tanstack/react-query';
import apiCall from '../../../../utils/apiCall';
import { NotificationContext } from '../../../../providers/notification';

const DisableAdmin = (props:any) => {
  const {setShowModal} = useSettingModal();
  const data = props?.data;
  const queryClient = useQueryClient();
  const { showNotification } = useContext(NotificationContext);

  const disableAdminUser = async (payload: string) => {
    return await (apiCall().put(`/Administration/DisableAdminUser/${data?.UserId}`, payload));
  };

  const disableAdminUserMutation = useMutation(['disable-admin-user'], disableAdminUser, {retry: 0});

  const disableAdminUserHandler = async () => {
    const payload: string = data?.UserId;
    try {
      await disableAdminUserMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: 'success',
            message: 'Admin user disabled successfully'
          })
          
          setShowModal(false);
          queryClient.refetchQueries(['get-admin-users']);
        }
      })
    } catch(error: any) {
      showNotification({
        type: 'error',
        message: error?.response?.data?.Message || error?.message
      })
    }
  }

  const handleDisableAdminUser = (e:any) =>{
    e.preventDefault();
    disableAdminUserHandler();
  }

  return (
    <ModalContainer style={{width:'400px',borderRadius:'8px'}}>
      <div>
        <div style={{borderRadius:'8px 8px 0 0'}}>
          <div>
            <IconContainer><UIcon /></IconContainer>
            <span>Disable Admin?</span>
          </div>
        </div>
        <Wrapper>
          <p>
            You are about to disable the Admin <span style={{fontWeight:'bold'}}>{data?.Email}</span>
          </p>
          <SubmitContainer>
          <span style={{cursor:"pointer"}} onClick={() => setShowModal(false)}>Cancel</span>
          <StyleButton style={{backgroundColor:'#DD5151',color:'#fff'}} onClick={handleDisableAdminUser}>
           {disableAdminUserMutation?.isLoading ? 'Disabling...' : 'Yes, Disable'} 
          </StyleButton> 
          
        </SubmitContainer>
        </Wrapper>
      </div>

    </ModalContainer>
  )
}

export default DisableAdmin;

const Wrapper = styled.form`
  min-height:200px;
  display:flex;
  flex-direction:column;
  gap: 20px;
  padding:20px;
  border-radius:0 0 8px 8px;
  
`